import React, { Component } from "react";
import store from "@/redux/store";

import {FieldHolder} from "@/components/holders/FieldHolder";

import { useForm, SubmitHandler, Controller } from "react-hook-form"
import  {IUser} from "@/models/User";
import  {IAddress} from "@/models/interfaces";
import { TenantUserFields } from "./TenantUserFields"; 
import { useNavigate, Link } from "react-router-dom";

export function Settings({...props}) {
    
  const { register, handleSubmit, watch, reset, control,   formState, formState: { isSubmitSuccessful } } = useForm<any>({
      defaultValues: props.data
    })
   const onSubmit: SubmitHandler<any> = (data) => {
        props.onSaveHandler(data);
      }

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
    
    
      return (
    <div className="space-y-10 divide-y divide-gray-900/10">
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSubmit)}>
          <div className="px-4 py-6 sm:p-8">

            <div className="mt-10 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
                  <input
                    id="func"
                    type="hidden"
                    {...register("func")}
                    defaultValue="settings"
                    className="component block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />

                  <input
                    id="key"
                    type="hidden"
                    data-dashlane-disabled-on-field="true"
                    {...register("key")}
                    key={(props.data && props.data.key) ?? null}
                    className="component block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />

            <div className="grid grid-cols-12 gap-3">
            <FieldHolder colspan="4" smcolspan="2" label="Wachtwoord" id="password" error={props?.state} >
                  <input
                    id="password"
                    type="password"
                    data-dashlane-disabled-on-field="true"
                    {...register("password")}
                    key={(props?.data?.password)}
                    className="component block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            
            <FieldHolder colspan="4" smcolspan="2" label="Herhaling wachtwoord" id="password2" error={props?.state} >
                  <input
                    id="password_confirmation"
                    type="password"
                    data-dashlane-disabled-on-field="true"
                    {...register("password_confirmation")}
                    key={(props?.data?.password_confirmation)}
                    className="component block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            
            
            </div>
    
            </div>
          </div>    
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to={(props.data && props.data.type == 1) ? "/team" : "/ext-team"} type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
        </form>
        
      </div>
      </div>
    
    );
}
